
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M18.333 30h3.333v-3.334h-3.333zM20 3.333A16.667 16.667 0 1036.666 20 16.673 16.673 0 0020 3.333zm0 30A13.333 13.333 0 1133.333 20 13.351 13.351 0 0120 33.333zM20 10a6.665 6.665 0 00-6.667 6.666h3.333a3.334 3.334 0 116.667 0c0 3.333-5 2.917-5 8.333h3.333c0-3.75 5-4.167 5-8.333A6.665 6.665 0 0020 10z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      